import { useEffect, useState } from 'react';

/** Tracks whether a CSS media query currently matches, so layout can switch (not just look) on phones. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange(); // the query string can change between renders; re-check rather than trust the initial state
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** Bootstrap's own `md` cutoff (max-width: 767.98px): phones and small tablets in portrait. */
export const useIsCompact = (): boolean => useMediaQuery('(max-width: 767.98px)');
